const styles = theme => ({
  imageContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
  },
  imageText: {
    color: 'var(--mcg-gray, #919EAB)',
    /* Body/Body 6 */
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px' /* 163.636% */,
  },
})

export default styles
